































import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

export default Vue.extend({
  name: "Separator",
  props: {
    title: String,
    subTitle: String,
  },
  computed: {
    ...mapGetters(["getLogoSrc"]),
  },
  data() {
    return {
      hasOtherLoginProviders: false,
      logoSrc: "",
    };
  },
  created() {
    this.loadLogo();
  },
  methods: {
    ...mapActions(["loadLogo"]),
  },
});
